import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { LoyaltyRewardRemote } from "../../infrastructure/loyalty-reward.remote";
import { LoyaltyRewardOffer } from "../models/loyalty-reward.model";
import { LoyaltyRewardStateService } from "./loyalty-reward.state.service";

@Injectable({ providedIn: "root" })
export class LoyaltyRewardFacade {
  constructor(
    private readonly stateService: LoyaltyRewardStateService,
    private readonly remote: LoyaltyRewardRemote,
  ) {}

  getOffer$(loanId: number): Observable<LoyaltyRewardOffer | null> {
    if (this.stateService.isOfferLoaded(loanId)) {
      return this.stateService.getOffer$();
    }
    return this.remote.getOffer(loanId).pipe(
      tap((offer) => this.stateService.setOffer(offer, loanId)),
      switchMap(() => this.stateService.getOffer$()),
    );
  }

  acceptOffer(loanId: number): Observable<void> {
    return this.remote.acceptOffer(loanId).pipe(
      tap(() => this.stateService.clearOffer()),
    );
  }

  clearOffer(): void {
    this.stateService.clearOffer();
  }
}
